module.exports = __webpack_public_path__ + "img/ky.d299de6e.svg";